import {Component, HostBinding, OnInit} from '@angular/core';
import {SnackbarService} from 'app/core';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GeneralService} from 'app/core';
import {
    AssignCompetitorShopCommand,
    StoreListQuery,
    StoreUpdateCommand,
    CompetitorShopListForOwnShopQuery
} from '../../model/models';
import {Location} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';
import {CompetitorShopDataService} from 'app/surroundings/shops-competitors/services/shops-comp.data.service';
import {mergeMap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {StoresDataService} from 'app/domain/shops-wrapper/shops/services/stores.data.service';
import {CurrentAssortmentService} from 'app/prices/current-assortment/services/current-assortment.service';
import {ClusterModel} from 'app/prices/current-assortment/models/cluster.model';

@Component({
    selector: 'sh-app-shop-create',
    templateUrl: './shop-create.component.html',
    styleUrls: []
})
export class ShopCreateComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow action-button-padding';

    store: StoreListQuery = {} as StoreListQuery;
    creatingForm: FormGroup;
    isSaving = false;
    ownShopId: number = null;
    selectedItems: CompetitorShopListForOwnShopQuery[] = [];
    displayedColumns: Array<String> = ['select'];
    idFieldName: string;
    columnsData: Array<any> = [];
    sortBy = 'Id desc';
    compShopsLocation: string[] = [];
    shopLocation: string = null;
    pageSize = 25;
    tableId: string;
    navigationBackArray = ['metadata', 'stores'];
    clusters: Array<ClusterModel>;

    constructor(
        public dataService: StoresDataService,
        public snackBar: SnackbarService,
        private route: ActivatedRoute,
        private _location: Location,
        public generalService: GeneralService,
        private formBuilder: FormBuilder,
        public compShopService: CompetitorShopDataService,
        private currentAssortmentService: CurrentAssortmentService
    ) {

    }

    ngOnInit() {
        this.columnsData = CompetitorShopListForOwnShopQuery.tableInfo();
        this.tableId = 'CompetitorShopListForOwnShopQuery';
        this.idFieldName = this.columnsData[0].columnDef;
        this.displayedColumns.push(...this.columnsData.map(c => c.columnDef), 'actions');

        this.ownShopId = +this.route.snapshot.paramMap.get('id');

        this.creatingForm = this.formBuilder.group({
            Name: ['', Validators.required],
            ZipCode: ['', Validators.required],
            City: ['', Validators.required],
            Region0: ['', Validators.required],
            Chain: ['', Validators.required],
            Street: ['', Validators.required],
            StreetNumber: [null, Validators.required],
            Code: [''],
            ClusterId: [''],
            Number: ['', Validators.required],
            Region1: [''],
            Country: ['', Validators.required],
            Surface: [''],
            CheckboxNb: [null],
            StockType: [null],
            FridgeBeer: [''],
            FridgeIceCream: [''],
        });

        if (this.ownShopId) {
            this.fillForm();
            this.fetchSelectCompShops();
        }

        this.currentAssortmentService
            .fetchClustersData()
            .subscribe((clusters) => {
                this.clusters = clusters.items;
            });
    }

    public getShopLocation() {
        const city = this.creatingForm.get('City').value;
        const street = this.creatingForm.get('Street').value;
        const streetNumber = this.creatingForm.get('StreetNumber').value;
        if (!city && !street) {
            return null;
        }
        this.shopLocation = `${city} ${street} ${streetNumber}`;
        // return `${city} ${street} ${streetNumber}`;
    }

    private deepObjectCopy(obj): any {
        return JSON.parse(JSON.stringify(obj));
    }

    private fetchSelectCompShops(): void {
        this.dataService.getCompetitorsShops(this.ownShopId)
            .subscribe(
                (res: CompetitorShopListForOwnShopQuery[]) => {
                    this.selectedItems = res;
                    this.setCompShopLocation(res);
                },
                err => console.log(err)
            );
    }

    private setCompShopLocation(compShops: CompetitorShopListForOwnShopQuery[]): void {
        const compShopsObj = this.deepObjectCopy(compShops);
        this.compShopsLocation = compShopsObj.map((compShop: CompetitorShopListForOwnShopQuery) => {
            const city = compShop.City;
            const street = compShop.AddressWithNR;
            return `${city} ${street}`;
        });
    }

    private fillForm() {
        this.dataService.getById(this.ownShopId)
            .subscribe(
                (compShop: StoreListQuery) => {
                    const changedShop = {
                        ...compShop,
                        FridgeBeer: (compShop.FridgeBeer === 'true'),
                        FridgeIceCream: (compShop.FridgeIceCream === 'true')
                    };
                    this.creatingForm.patchValue(changedShop);
                    // fill shop location
                    this.getShopLocation();
                },
                (err) => {
                    if (err.status !== 403) {
                        this.snackBar.info('Wystąpił błąd podczas zapytania');
                    }
                    console.log(err);
                }
            );
    }

    public checkIfCreatePage(): boolean {
        return !this.ownShopId;
    }

    // submiting through hidden button to validate field
    // if submit form on click it won't validate fields
    public onSubmit() {
        if (!this.creatingForm.valid) {
            this.snackBar.info('Wszystkie pola muszą być wypełnione.');
            return;
        }
        let form = null;
        let createObs: Observable<any>;
        if (this.ownShopId) {
            form = this.formUpdateData();
            createObs = this.dataService.update(form);
        } else {
            form = this.creatingForm.value;
            createObs = this.dataService.create(form);
        }
        this.isSaving = true;
        createObs
            .pipe(
                mergeMap((shopId: number) => {
                    if (!shopId) {
                        throw Error('no shop id!');
                    }
                    const formAssignForm = this.formAssignForm(shopId);
                    return this.dataService.assignCompToShop(formAssignForm);
                })
            )
            .subscribe(
                res => console.log(res),
                err => this.shopError(err),
                () => this.shopCreated()
            );
    }

    private formAssignForm(storeId: number): AssignCompetitorShopCommand {
        return {
            storeId: storeId,
            compStoreIds: this.selectedItems.map(shop => shop.Id)
        };
    }

    private formUpdateData(): StoreUpdateCommand {
        return {...this.creatingForm.value, Id: this.ownShopId};
    }

    public addNewRow(row: CompetitorShopListForOwnShopQuery) {
        // for changes to be seen in child components
        if (this.selectedItems.find(item => item.Id === row.Id)) {
            return;
        }
        this.selectedItems = [...this.selectedItems, row];
        this.setCompShopLocation(this.selectedItems);
    }

    public removeSelectedRow(row: number) {
        // for changes to be seen in child components
        this.selectedItems = this.selectedItems.filter(item => item[this.idFieldName] !== row);
        this.setCompShopLocation(this.selectedItems);
    }

    private shopCreated(): void {
        this.isSaving = false;
        const shopCreateText = this.checkIfCreatePage() ? 'Placówka została utworzony.' : 'Zmiany zostały zapisane.';
        this.snackBar.info(shopCreateText);
        this._location.back();
    }

    private shopError(err: HttpErrorResponse) {
        this.isSaving = false;
        if (err.status === 409) {
            this.snackBar.info('Podobna placówka już istnieje w bazie.');
            return;
        } else if (err.status !== 403) {
            this.snackBar.info('Podczas zapisywania wystąpił błąd.');
        }
    }

    public navigationBack(): void {
        this.generalService.navigateTo(this.navigationBackArray);
    }
}
